<div>
  <ul>
    <li *ngFor="let warning of warnings">
      Your cart contains <span class="bold">{{warning.totalQuantity}} kits</span> of {{warning.name}} but your selected tests
      only require <span class="bold">{{warning.requiredQuantity}} kit{{warning.requiredQuantity > 1 ? 's' :
        ''}}</span>.
    </li>
  </ul>
  <div class="bold center">Do you want to remove the extra kit{{this.totalExtraKits > 1 ? 's' : ''}}?</div>
</div>